// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"273":"37a5398c","375":"f81c8e2f","607":"9a552922","765":"910a51ef","767":"2ac25316","887":"11000979"}[chunkId] + ".js";
};